var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('script',{attrs:{"type":"application/javascript","src":"./assets/js/jquery.min.js"}}),_c('script',{attrs:{"type":"application/javascript","src":"./assets/js/bootstrap.bundle.min.js"}}),_c('script',{attrs:{"type":"application/javascript","src":"/assets/js/slick.min.js"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }